// extracted by mini-css-extract-plugin
module.exports = {"gameDetails":"GameDetails_gameDetails__1PuLA","gameDetailsPreview":"GameDetails_gameDetailsPreview__jQEuB"};